import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { getPublicDog } from "../dogs/api";
import { PublicDogProfilePage } from "./DogPublicPages";

export function PublicDogAuthorityPage() {
  const { slug = "" } = useParams();
  const { principal, loading: authLoading } = useAuth();
  const [dogId, setDogId] = useState<string | null>(null);
  const [registeredName, setRegisteredName] = useState<string>("");

  useEffect(() => {
    if (!slug) return;
    let active = true;
    getPublicDog(slug)
      .then(({ dog }) => {
        if (!active) return;
        setDogId(dog.id);
        setRegisteredName(dog.registeredName);
      })
      .catch(() => {
        if (!active) return;
        setDogId(null);
      });
    return () => {
      active = false;
    };
  }, [slug]);

  const authorityPath = dogId ? `/member/dogs/${dogId}/ownership` : "/member/ownership/dogs";
  const loginPath = `/login?returnTo=${encodeURIComponent(authorityPath)}`;

  return (
    <>
      <PublicDogProfilePage />
      {dogId ? (
        <section className="public-dog-authority-entry page-container" data-testid="public-dog-pedigree-entry">
          <div>
            <h2>Phả hệ có nguồn và xác minh</h2>
            <p>Xem cây 3–5 thế hệ, siblings, offspring và lịch sử nguồn của từng quan hệ.</p>
          </div>
          <Link className="ui-button ui-button--secondary ui-button--md" to={`/dogs/${slug}/pedigree`}>
            Xem phả hệ
          </Link>
        </section>
      ) : null}
      {dogId && !authLoading ? (
        <section className="public-dog-authority-entry page-container" data-testid="public-dog-authority-entry">
          <div>
            <h2>Ownership và quyền chỉnh sửa</h2>
            <p>
              {principal
                ? `Quản lý quyền hiện hành hoặc gửi claim có evidence cho ${registeredName}.`
                : `Đăng nhập để gửi claim có evidence cho ${registeredName}.`}
            </p>
          </div>
          <Link
            className="ui-button ui-button--primary ui-button--md"
            to={principal ? authorityPath : loginPath}
          >
            {principal ? "Quản lý / claim quyền" : "Đăng nhập để claim"}
          </Link>
        </section>
      ) : null}
    </>
  );
}
